import { render } from "./MediaExplorer.vue?vue&type=template&id=52dedb86"
import script from "./MediaExplorer.vue?vue&type=script&lang=js"
export * from "./MediaExplorer.vue?vue&type=script&lang=js"

import "./MediaExplorer.vue?vue&type=style&index=0&id=52dedb86&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__